<p-card class="">
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Actividades
        </div>
    </ng-template>    
    <div class="color-danger" *ngIf="ret.days_last_activity == null">No se han realizado actividades.</div>
    <div class="color-danger" *ngIf="ret.days_last_activity == 0">Última actividad creada <b>hoy mismo</b>.</div>
    <div class="color-danger" *ngIf="ret.days_last_activity == 1">Última actividad creada <b>ayer</b>.</div>
    <div class="color-danger" *ngIf="ret.days_last_activity > 1"><b>{{ret.days_last_activity}}</b> días desde última actividad</div>
    <div><b>{{ret.pending_activities}}</b> actividades pendientes</div>
</p-card>